const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-PrecompiledFileSelector',
			DefaultInputExtensions: [ 'PrecompiledFileSelector' ],
			Template: /*HTML*/`
			<!-- InputType PrecompiledFileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="PREVIOUS-VALUE-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
			 />
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
			 />
			<div class="column {~ColumnWidth:Record~}" id="PARENT-FOR-{~D:Record.Macro.RawHTMLID~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-checkbox-with-label pb-3 mb-0 has-addons has-addons-right {~ColumnAlignment:Record~}">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							style="padding-right: 40px;"
							disabled="disabled"
							placeholder="{~Placeholder:Record~}"
							autocomplete="off"
							value=""
						></div>
					</p>
					<p class="control">
						<button
							id="CLEAR-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="button is-ghost"
							type="button"
							style="position: absolute; right: 0; width: 40px; visiblity: hidden;"
							onclick="
								const ele = {~P~}.ContentAssignment.getElement('#{~D:Record.Macro.RawHTMLID~}')[0];
								if (ele)
								{
									ele.value = '';
									{~P~}.views['{~D:Context[0].Hash~}'].dataChanged('{~D:Record.Hash~}');
								}"
						>
							<span class="icon">
								<i class="fa fa-fw fa-times"></i>
							</span>
						</button>
					</p>
					<p class="control">
						<button
							id="EDIT-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="button is-link"
							type="button"
							onclick="{~P~}.views.HeadlightPaneObservations.selectObservations({
								SingleSelect: true,
								FileType: 'application/pdf',
								UIFocusViewHash: '{~D:Record.Hash~}',
								UIFocusInputName: 'Precompiled PDF',
								SearchActionLabel: 'Select'
							},
							(obsInfos) =>
							{
								if (obsInfos.length > 0)
								{
									const ele = {~P~}.ContentAssignment.getElement('#{~D:Record.Macro.RawHTMLID~}')[0];
									if (ele)
									{
										ele.value = obsInfos[0].IDObservation;
										{~P~}.views['{~D:Context[0].Hash~}'].dataChanged('{~D:Record.Hash~}');
									}
								}
							})"
						>
							<span class="icon">
								<i class="fa fa-fw fa-paperclip"></i>
							</span>
							<span>Attach PDF</span>
						</button>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-PrecompiledFileSelector',
			DefaultInputExtensions: [ 'PrecompiledFileSelector' ],
			Template: /*HTML*/`
			<!-- InputType PrecompiledFileSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="PREVIOUS-VALUE-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
			 />
			<input
				id="{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
			 />
			<div class="column {~ColumnWidth:Record~}" id="PARENT-FOR-{~D:Record.Macro.RawHTMLID~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-checkbox-with-label pb-2 mb-0 has-addons has-addons-right {~ColumnAlignment:Record~}">
					<p class="control control-status is-expanded">
						<span class="control-status-icon"></span>
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							style="padding-right: 40px;"
							disabled="disabled"
							autocomplete="off"
							value=""
						></div>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-PrecompiledFileSelector',
			DefaultInputExtensions: [ 'PrecompiledFileSelector' ],
			Template: /*HTML*/`<!-- InputType PrecompiledFileSelector {~D:Record.Hash~} {~D:Record.DataType~} (does not print) -->`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
